import React, {useState, createContext, useContext} from "react";

const PlayerContext = createContext();

export default function PlayerProvider({children}){
    
    const [player, setPlayer] = useState(null);

    return(
        <PlayerContext.Provider value={{player, setPlayer}}>
            {children}
        </PlayerContext.Provider>
    );
}

export function usePlayer(){
    const player = useContext(PlayerContext);
    return player;
  }